export const environment = {
  production: false,
  apiUrl: 'https://platform-stage.getbevvi.com',
  chatApiUrl: 'https://agent-stage.getbevvi.com',
};
